let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("dAn5k"), load("jle6Z"), load("ffEVr"), load("hhss7"), load("878st")]).then(() => parcelRequire('iVuad'));